// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5024":"css/app.6911","5807":"css/admin-app.6911"}[chunkId] + ".css";
};